export const FETCH_DETAILS = 'user/FETCH_DETAILS'
export const UPDATE_DETAILS_USER = 'user/UPDATE_DETAILS_USER'



// WEBPACK FOOTER //
// ./client/store/modules/user/mutation-types.js